// extracted by mini-css-extract-plugin
export default {"Avatar":"Avatar_Avatar__7tEin","Editable":"Avatar_Editable__A9xc7","Rounder":"Avatar_Rounder__IWYlK","Disabled":"Avatar_Disabled__9+tsS"};